import {getClosest} from './globals';

const itemsWithSubmenu = document.querySelectorAll('#primary-navigation .has-children');
const allPrimaryLinks = document.querySelectorAll('#primary-navigation a');

var addTabletTouchControls = function(elem) {
  elem.addEventListener("touchend", function(e) {

    //check that tapped element has a parent that is not yet focused and has a dropdown
    var isTabletAndClosed = ( (getClosest(this.parentNode, '.focus') === null || getClosest(this.parentNode, '.focus') === undefined )
                              && window.innerWidth >= 1024
                              && ( getClosest(this.parentNode, '.has-children') != null || getClosest(this.parentNode, '.has-children') != undefined ) )
                               ? true : false;

    //if satisfied, stop default link action
    if (isTabletAndClosed) {
      e.preventDefault();
      e.stopPropagation();

      //remove focus state from other menus
      for (var i=0; i < itemsWithSubmenu.length; i++) {
        itemsWithSubmenu[i].classList.remove('focus');
      }

      //add focus state to tapped on menu item
      this.parentNode.classList.add('focus');
    }

  });
}

for (var l=0; l < allPrimaryLinks.length; l++) {
  addTabletTouchControls(allPrimaryLinks[l]);
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/tablet-nav-controls.js